module.exports = __webpack_public_path__ + "img/dark_seat.572d9ffb.png";